import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GalleryCategoryItem } from './GalleryCategoryItem';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import { getGalleryFeed } from '../../utils/api/services/gallery';
import paths from '../../paths';
import Preloader from '../../components/Preloader/Preloader';
import ListFooter from '../../components/ListFooter/ListFooter';
import { setUrlParameters } from '../../utils/helpers';
import { getPage } from '../../utils/urlHelper'; 

export class GalleryCategoryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            gallery: []
        };
    }

    componentWillMount = () => {
        this.fetchData();
    };

    fetchData = () => {
        this.setState({ isLoading: true });
        getGalleryFeed()
            .then((result) => {
                console.log(result);
                this.setState({
                    gallery: result
                });
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search !== this.props.location.search) {
            this.fetchData();
        }
    }

    render() {
        const {
            isLoading, gallery
        } = this.state;

        if (isLoading && !gallery.length) {
            return <Preloader />;
        }

        return (
            <div className="b-center">

                <BreadCrumbs
                    data={[{ url: paths.advocates.main, text: 'Главная' }, { url: paths.advocates.gallery, text: 'Галерея' }]}
                />

                <h1 className="title -primary">Галерея</h1>


                <div className="gallery-main">
                    {gallery.length ? (
                        <GalleryListContent
                            gallery={gallery}
                        />
                    ) : (
                            <div>Галереи нет :(</div>
                        )}
					   
				</div>
				

					
					
            </div>
       )
    }
}

const GalleryListContent = ({
    gallery
}) => (
        <React.Fragment>
            {gallery.length ? (
                gallery.map(item => (
                    <GalleryCategoryItem
                            alias={item.alias}
                            name={item.name}
                            image={item.coverImageId}
                        />
                    ))
                ) : (
                        <div>Новостей нет</div>
                    )}
        </React.Fragment>
    );
